import { render, staticRenderFns } from "./imprTabDetail.vue?vue&type=template&id=12e0d576"
import script from "./imprTabDetail.vue?vue&type=script&lang=js"
export * from "./imprTabDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e0d576')) {
      api.createRecord('12e0d576', component.options)
    } else {
      api.reload('12e0d576', component.options)
    }
    module.hot.accept("./imprTabDetail.vue?vue&type=template&id=12e0d576", function () {
      api.rerender('12e0d576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/ibm/imprTabDetail.vue"
export default component.exports